import 'react-phone-number-input/style.css'
import 'react-toggle/style.css'
import './styles.css'

import { useMutation } from '@apollo/client'
import classNames from 'classnames'
import React, { useContext } from 'react'
import Toggle from 'react-toggle'

import { PROFILE_CONTEXT } from '../../contexts/settings/profile'
import { BellIcon, KeyIcon, ToggleIcon } from './icons'
import { UPDATE_NOTIFICATION } from './queries'

export const I18n = {
    HEADING: 'Profile information',
    SUB_HEADING:
        'Please provide the following information so we can provide the best experience for you',
    FIRST_NAME_LABEL: 'First name*',
    LAST_NAME_LABEL: 'Last name*',
    DOB_LABEL: 'Date of birth*',
    SELF_DESCRIPTION_LABEL: 'What best describes you?*',
    PRODUCT_INTEREST_LABEL: 'What products are you interested in?*',
    COUNTRY_LABEL: 'Country of residence?*',
    SUBMIT: 'Edit',
    FOOTER_MESSAGE: 'Your info is safely secured and encrypted',
    EMAIL_LABEL: 'Email',
    PHONE_LABEL: 'Phone',
}

export function SecurityAndLogin() {
    const { formData, updateFormData }: any = useContext(PROFILE_CONTEXT)
    const [updateNotifications] = useMutation(UPDATE_NOTIFICATION)
    const containerStyles = classNames('px-12 py-4 flex flex-col w-full')

    const headerStyles = classNames('border-b border-gray2 pb-6 mb-2')
    const headerTitleStyles = classNames('text-xl')

    const labelStyle = classNames('text-gray4 font-semibold text-lg mb-4')

    const sectionStyles = classNames('py-4 border-b border-gray2')
    const subtitleStyles = classNames('text-gray4 text-sm')

    const changePasswordStyles = classNames(
        'group',
        'bg-white rounded-sm',
        'border border-danger box-border',
        'shadow-md',
        'transition-opacity',
        'hover:opacity-100',
        'flex flex row p-2 items-center px-8 cursor-pointer',
        'text-danger',
        'hover:bg-danger hover:text-white',
    )

    return (
        <div className={containerStyles}>
            <div className={headerStyles}>
                <h4 className={headerTitleStyles}>Security & login</h4>
            </div>
            <div className={sectionStyles}>
                <h5 className={labelStyle}>Recommended</h5>
                <div className='flex flex-row'>
                    <div className='h-full pr-8'>
                        <BellIcon />
                    </div>
                    <div className='flex flex-col'>
                        <p className={subtitleStyles}>Security alerts</p>
                        <p className='text-xs'>
                            Improve the security of you account by getting
                            alerts when someone logs into your account from an
                            unknown device or browser
                        </p>
                    </div>
                    <div className='flex flex-col items-center justify-center w-1/5 gap-y-4'>
                        <div className='flex flex-row items-center justify-center gap-x-2'>
                            <Toggle
                                className='toggle'
                                icons={{
                                    checked: null,
                                    unchecked: <ToggleIcon />,
                                }}
                                value={formData.notifyPhone}
                                onChange={({
                                    target: { checked },
                                }: {
                                    target: { checked: boolean }
                                }) => {
                                    updateFormData({ notifyPhone: checked })
                                    updateNotifications({
                                        variables: {
                                            input: { notifyPhone: checked },
                                        },
                                    })
                                }}
                            />
                            <p className='p-0 m-0'>SMS</p>
                        </div>
                        <div className='flex flex-row items-center justify-center gap-x-2'>
                            <Toggle
                                icons={{
                                    checked: null,
                                    unchecked: <ToggleIcon />,
                                }}
                                className='toggle'
                                value={formData.notifyEmail}
                                onChange={({
                                    target: { checked },
                                }: {
                                    target: { checked: boolean }
                                }) => {
                                    updateFormData({ notifyEmail: checked })
                                    updateNotifications({
                                        variables: {
                                            input: { notifyEmail: checked },
                                        },
                                    })
                                }}
                            />
                            <p className='p-0 m-0'>Email</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className={sectionStyles}>
                <h5 className={labelStyle}>Recommended</h5>
                <div className='flex flex-row items-center'>
                    <div className='flex flex-col justify-start h-16 pr-8 '>
                        <KeyIcon />
                    </div>
                    <div className='flex flex-col flex-grow '>
                        <p className={subtitleStyles}>Password</p>
                        <p className='text-sm'>Password last updated -</p>
                    </div>
                    <div
                        className={changePasswordStyles}
                        style={{
                            width: 'max-content',
                        }}
                        onClick={() => {}}>
                        Change password
                    </div>
                </div>
            </div>
            {/* <div className={sectionStyles}>
                <h5 className={labelStyle}>Recent logins</h5>
                <div className='flex flex-row'>
                    <div>//icon</div>
                    <div className='flex flex-col'>
                        <p className={subtitleStyles}>Security alerts</p>
                        <p>
                            Improve the security of you account by getting
                            alerts when someone logs into your account from an
                            unknown device or browser
                        </p>
                    </div>
                    <div>Toggles</div>
                </div>
            </div> */}
        </div>
    )
}
